import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useMonthOptions = () => {
    const { t } = useTranslation();

    return useMemo(
        () => [
            t('months.january'),
            t('months.february'),
            t('months.march'),
            t('months.april'),
            t('months.may'),
            t('months.june'),
            t('months.july'),
            t('months.august'),
            t('months.september'),
            t('months.october'),
            t('months.november'),
            t('months.december'),
        ],
        [t],
    );
};
